import { Model } from 'infra/model'
import { PersonalInfoDto } from './dtos'
import { computed, makeObservable, observable } from 'mobx'

export class PersonalInfo extends Model<PersonalInfoDto, PersonalInfo> {
  @observable firstName = ''

  @observable middleInitial = ''

  @observable lastName = ''

  @observable dateOfBirth = ''

  @observable personalTaxpayerIdentificationNumber = ''

  constructor() {
    super()
    makeObservable(this)
  }

  @computed
  get fullName() {
    return [this.firstName, this.middleInitial, this.lastName]
      .filter(Boolean)
      .join(' ')
  }

  @computed
  get personalTaxpayerIdentificationNumberDisplay() {
    return this.personalTaxpayerIdentificationNumber.replace(
      /\d{3}-\d{2}-(\d{4})/,
      '✶✶✶-✶✶-$1',
    )
  }

  parse(attrs: PersonalInfoDto): Partial<PersonalInfo> {
    return {
      firstName: attrs.firstName,
      middleInitial: attrs.middleInitial,
      lastName: attrs.lastName,
      dateOfBirth: attrs.dateOfBirth,
      personalTaxpayerIdentificationNumber:
        attrs.personalTaxpayerIdentificationNumber,
    }
  }
}
